import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../components/AuthContext"; // ✅ doğru yol

const getByPath = (obj, path) => {
  if (!obj || !path) return undefined;
  return path.split(".").reduce((acc, key) => (acc ? acc[key] : undefined), obj);
};

const PrivateRoute = ({ children, izin }) => {
  const auth = useAuth();
  if (!auth) return <div>❌ AuthContext bulunamadı.</div>;

  const { user, role, userPermissions, loading } = auth;

  if (loading) return <div style={{ textAlign: "center", marginTop: 40 }}>Yükleniyor...</div>;
  if (!user || !role) return <Navigate to="/giris" replace />;

  const normalizedRole = (role || "").toString().toLocaleLowerCase("tr-TR");

  // 1) Özel durum: oluşturucu rolü her şeye erişebilir
  if (normalizedRole === "oluşturucu") {
    return children;
  }

  // 2) Eğer izin tam "olusturucu" ise, rol "oluşturucu" olmalı
  if (izin === "olusturucu" && normalizedRole !== "oluşturucu") {
    return <div style={{ textAlign: "center", marginTop: 40 }}>Yetkisiz Erişim</div>;
  }

  // 3) Dot-path ve fallback kontrolü
  const dotValue = getByPath(userPermissions || {}, izin); // örn: fatura.yonetici
  const flatKey = izin?.includes(".") ? izin.split(".").pop() : izin; // "yonetici"
  const flatValue = (userPermissions || {})[flatKey];               // userPermissions.yonetici

  const allowed = typeof dotValue !== "undefined" ? !!dotValue : !!flatValue;

  if (!allowed) {
    return <div style={{ textAlign: "center", marginTop: 40 }}>Yetkisiz Erişim</div>;
  }

  return children;
};

export default PrivateRoute;
